import { Label } from "@/components/ui/label";

interface TherapeuticCategorySelectorProps {
  selected: string[];
  onChange: (categories: string[]) => void;
}

const therapeuticCategories = [
  "analgesics", "antacids", "antibacterials", "antibiotics", "anticancer",
  "anticoagulant", "antidepressants", "antidiabetic", "antidiarrheal",
  "antiepileptic", "antifungals", "antihistamines", "anti-inflammatories",
  "antipsychotic", "antipyretics", "antispasmodic", "antiviral", "asthma",
  "cardiology", "cardiovascular", "cold-and-cough", "dental", "depressant",
  "dermatology", "diabetic", "endocrinology", "endocrinology-hormonal",
  "gastroenterology", "general-otc", "gynecology-fertility", "hepatology",
  "hypertension", "immunology", "laxatives", "nephrology", "neurology",
  "nutraceuticals", "oncology", "ophthalmology", "orthopedics", "pediatrics",
  "pulmonary", "respiratory", "rheumatology", "sedative-antianxiety",
  "stimulant", "urology",
];

export default function TherapeuticCategorySelector({ selected, onChange }: TherapeuticCategorySelectorProps) {
  const handleToggle = (category: string) => {
    if (selected.includes(category)) {
      onChange(selected.filter(c => c !== category));
    } else {
      onChange([...selected, category]);
    }
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="therapeuticCategory">Therapeutic Category</Label>
      <div className="border rounded-lg p-4 max-h-48 overflow-y-auto">
        <div className="grid grid-cols-2 gap-2">
          {therapeuticCategories.map((category) => (
            <label key={category} className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={selected.includes(category)}
                onChange={() => handleToggle(category)}
                className="rounded"
              />
              <span className="text-sm capitalize">{category.replace(/-/g, ' ')}</span>
            </label>
          ))}
        </div>
      </div>
      <p className="text-xs text-muted-foreground">
        Select all therapeutic areas this product applies to
      </p>
    </div>
  );
}
